module.exports = ".input-group:first-child {\n  width: 60%;\n  margin-right: 30px; }\n"